import { render, staticRenderFns } from "./LiveopsWhitepaperHomepage.vue?vue&type=template&id=7c8391b1&scoped=true&"
import script from "./LiveopsWhitepaperHomepage.vue?vue&type=script&lang=ts&"
export * from "./LiveopsWhitepaperHomepage.vue?vue&type=script&lang=ts&"
import style0 from "./LiveopsWhitepaperHomepage.vue?vue&type=style&index=0&id=7c8391b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8391b1",
  null
  
)

export default component.exports